import { FC } from 'react';
import { CheckboxProps } from './checkbox.type';

const Checkbox: FC<CheckboxProps> = (props) => {
  return (
    <input
      type="checkbox"
      checked={props.checked}
      onClick={props.onClick}
      onChange={(e) => props.onChange(e.target.checked)}
      className={`form-checkbox h-4 w-4 ml-10 mt-5  accent-THEME_COLOR  rounded disabled:cursor-not-allowed ${props.className}`}
    />
  );
};

export default Checkbox;
